import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faSquareInstagram, faSquareFacebook } from '@fortawesome/free-brands-svg-icons';

const icons = {
    faEnvelope,
    faSquareInstagram,
    faSquareFacebook,
    linktree: (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="white" d="m13.736 5.853l4.005-4.117l2.325 2.38l-4.2 4.005h5.908v3.305h-5.937l4.229 4.108l-2.325 2.334l-5.74-5.769l-5.741 5.769l-2.325-2.325l4.229-4.108H2.226V8.121h5.909l-4.2-4.004l2.324-2.381l4.005 4.117V0h3.472zm-3.472 10.306h3.472V24h-3.472z" />
        </svg>
    )
};

export function ContactItem({ contact }) {
    const renderIcon = (icon, iconType) => {
        if (iconType === 'fontawesome') {
            return <FontAwesomeIcon icon={icons[icon]} />;
        } else if (iconType === 'svg') {
            return icons[icon];
        }
        return null;
    };
    if (contact.type === "email") {
        return (
            <div className="d-flex text-light mb-4">
                <div className="btn btn-outline-light btn-social"><FontAwesomeIcon icon={icons[contact.icon]} /></div>
                <div className="btn btn-outline-light btn-social">{contact.address}</div>
            </div>
        );
    } else if (contact.type === "social") {
        return (
            <div className="d-flex text-light mb-4">
                <a className="btn btn-outline-light btn-social" href={contact.url}>
                    {renderIcon(contact.icon, contact.iconType)}
                </a>
                <a className="btn btn-outline-light" href={contact.url}>{contact.platform}</a>
            </div>
        );
    }
    return null;
}